<template>
  <div>
    <a-space>
      <a-input-search
        class="query"
        @dblclick="()=>this.$refs.storageRoomModal.open()"
        @search="()=>this.$refs.storageRoomModal.open()"
        @pressEnter="search"
        :placeholder="$t('placeholder.storageRoom')"
        readOnly
        v-model="query['storageRoom.name']"
      />
      <a-input-search
        class="query"
        @dblclick="()=>this.$refs.zoneModal.open({'storageRoom.id':this.query['storageRoom.id']})"
        @search="()=>this.$refs.zoneModal.open({'storageRoom.id':this.query['storageRoom.id']})"
        @pressEnter="search"
        :placeholder="$t('placeholder.zone')"
        readOnly
        v-model="query['zone.name']"
      />
      <a-input-search
        class="query"
        @dblclick="()=>this.$refs.locationModal.open({'storageRoom.id':this.query['storageRoom.id'],'zone.id':this.query['zone.id']})"
        @search="()=>this.$refs.locationModal.open({'storageRoom.id':this.query['storageRoom.id'],'zone.id':this.query['zone.id']})"
        @pressEnter="search"
        :placeholder="$t('placeholder.location')"
        readOnly
        v-model="query['location.no']"
      />
      <a-select class="query" v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear>
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-input-search
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('placeholder.itemNo')"
        v-model="query['item.no']"
      />
    </a-space>
    <br/><br/>
    <a-space>
      <a-input-search
        class="query"
        @dblclick="()=>this.$refs.employeeModal.open({available:true})"
        @search="()=>this.$refs.employeeModal.open({available:true})"
        @pressEnter="search"
        :placeholder="$t('placeholder.inventoryClerk')"
        v-model="query['operator']"
      />
      <a-select class="query"
                :placeholder="$t('placeholder.pleaseSelectCountingType')"
                allowClear
                @change="(e)=>{if(e){this.query['changed']=(e===1)}else{this.query['changed']=undefined}}">
        <a-select-option :value="1">
          {{$t('option.outboundCounting')}}
        </a-select-option>
        <a-select-option :value="2">
          {{$t('option.notOutboundCounting')}}
        </a-select-option>
      </a-select>
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        v-model="query.range"
        :placeholder="[$t('placeholder.startTime'),$t('placeholder.endTime')]"
      />
      <a-space>
        <a-button type="primary" @click="init">{{$t('button.reset')}}</a-button>
        <a-button type="primary" @click="search">{{$t('button.query')}}</a-button>
        <a-button type="primary" @click="print">{{$t('button.print')}}</a-button>
      </a-space>
    </a-space>
    <br/><br/>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="batch.no" title="business.label.batchNo"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
      <vxe-column field="inventory.quantity" title="business.label.quantity"/>
      <vxe-column field="inventory.inventoryState" title="business.label.inventoryStatus">
        <span slot-scope="{ row }">{{inventoryStateData.find(item => item.ordinal === row.inventory.inventoryState).name}}</span>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <storage-room-modal ref="storageRoomModal" @change="setStorageRoom"/>
    <zone-modal ref="zoneModal" @change="setZone"/>
    <location-modal ref="locationModal" @change="setLocation"/>
    <employ-modal ref="employeeModal" @change="setOperator"/>
  </div>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import StorerModal from '@/views/modal/StorerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import EmployModal from '@/views/modal/UserModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'CountingPlan',
  components: { EmployModal, LocationModal, ZoneModal, StorageRoomModal, StorerModal },
  data() {
    return {
      size: 20,
      page: 1,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: {
        'storer.id': undefined,
        'item.no': null,
        'storageRoom.id': null,
        'storageRoom.name': null,
        'zone.id': null,
        'zone.name': null,
        'changed': undefined,
        'location.no': null,
        operator: null,
        dateFilter: null,
        range: []
      },
      inventoryStateData: [],
      countingTypeData: [
        {
          changed: true,
          name: '动销盘点'
        },
        {
          changed: false,
          name: '非动销盘点'
        }
      ],
      storerData: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.68)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  mounted() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStateData = res.result
      }
    })
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storerData = res.result
      }
    })
    this.getData()
  },
  methods: {
    init() {
      this.query = {
        'storer.id': undefined,
        'item.no': null,
        'storageRoom.id': null,
        'storageRoom.name': null,
        'zone.id': null,
        'zone.name': null,
        'changed': undefined,
        'location.no': null,
        'operator': null,
        dateFilter: null,
        range: []
      }
      this.data = []
      this.page = 1
      this.getData()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      let args = Object.assign({}, this.query)
      if (args.range.length !== 0) {
        args.dateFilter = { start: args.range[0], end: args.range[1] }
      } else {
        args.dateFilter = null
      }
      args.range = undefined
      findAll('countingInventoryPlanningFactory', args, this.page, this.size)
        .then((res) => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
        }).finally(() =>
        this.loading = false
      )
    },
    search() {
      this.page = 1
      this.getData()
    },
    setStorageRoom(storageRoomData) {
      if (storageRoomData.length !== 0) {
        let sr = storageRoomData[0]
        this.query['storageRoom.id'] = sr.id
        this.query['storageRoom.name'] = sr.name
        this.query['zone.id'] = null
        this.query['zone.name'] = null
        this.query['location.no'] = null
      } else {
        this.query['storageRoom.id'] = null
        this.query['storageRoom.name'] = null
        this.query['zone.id'] = null
        this.query['zone.name'] = null
        this.query['location.no'] = null
      }
    },
    setZone(zoneData) {
      if (zoneData.length !== 0) {
        let zone = zoneData[0]
        this.query['zone.id'] = zone.id
        this.query['zone.name'] = zone.name
        this.query['location.no'] = null
      } else {
        this.query['zone.id'] = null
        this.query['zone.name'] = null
        this.query['location.no'] = null
      }
    },
    setLocation(locationData) {
      if (locationData.length !== 0) {
        let location = locationData[0]
        this.query['location.no'] = location.no
      } else {
        this.query['location.no'] = null
      }
    },
    setOperator(operatorData) {
      if (operatorData.length !== 0) {
        let operator = operatorData[0]
        this.query['operator'] = operator.name
      } else {
        this.query['operator'] = null
      }
    },
    print() {

    }
  }
}
</script>
<style scoped>
.query {
  width: 250px;
}
</style>
